// Module
var code = "<div class=\"btn-group\"><select class=\"form-control btn\" ng-model=\"newFilter.user_value\" ng-options=\"month[0] as month[1] for month in months\"><option value=\"\">Month</option></select></div>\n";
// Exports
module.exports = code;